import React, { Component } from 'react';
import styled from 'styled-components';
import { errorResponse, makeRequest } from 'js/services/Network';
import { redColor } from 'js/config/style';

const Container = styled.div`
  font-size: 14px;
`;

const Link = styled.a`
  max-width: 100%;
  max-height: 100%;
  color:${redColor};
`;

const Span = styled.span`
`;

export default class UpdateStatus extends Component {
  state = {
    isSaving: false,
  }

  render() {
    return (
      <Container>
        {this.state.isSaving ? (
          <Span>Saving...</Span>
        ) : (
          <Link onClick={this.updateStatus.bind(this)} href="#">Update Status</Link>
        )}
      </Container>
    );
  }

  async updateStatus(e) {
    e.preventDefault();
    try {
      this.setState({ isSaving: true });
      self.orderId = this.props.orderId;
      const data = await makeRequest('admin-order-update-status', self);
      this.setState({ isSaving: false });
      if(data.data == 'success'){
        this.props.forceReload();
      }
    } catch (error) {
      this.setState({ isSaving: false });
    }
  }
}
